/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { Modern, styled, useFlux } from 'fierry/react.old';
import { List, Item, Link, Bold } from 'astro/react/element/welcome';

import Url from 'shared/client/url';

import NextButton from 'astro/react/button/general/next'
import LogInButton from 'astro/react/button/general/login'

import * as Manual from 'astro/fake/manual';


const WelcomeContainer = styled.div`
  user-select: text;
`;


const Card = styled(Modern.Group)`
  padding: 1.5rem; // 3rem right

  --native-foreground-color: var(--fierry-theme-foreground, black);
  --native-background-color: var(--fierry-theme-background, white);
`;


const Component = ({ index, ...props }) =>
(
  <WelcomeContainer>

    <Card>
      <Modern.Text param>{Manual.getText(index)}</Modern.Text>
    </Card>

  </WelcomeContainer>
);


export default (props) =>
{
  const [ url ] = useFlux(Url);

  const index = Number.parseInt(url.getRoute().getArgs().index);

  return <Component {...props} index = {index || 0} />;
}
